export default __webpack_public_path__ + "static/media/search.8a990e9e.svg";